<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键词" name='keyword'>
      <a-input v-model:value="search.keyword" style="width:270px" placeholder="请输入卡券名称/ID进行搜索" />
    </a-form-item>
    <a-form-item label="券类型" name='coupon_type'>
      <a-select v-model:value="search.coupon_type" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部类型</a-select-option>
        <a-select-option :value="2">现金券</a-select-option>
        <a-select-option :value="3">代金券</a-select-option>
        <a-select-option :value="1">折扣券</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:amount_text="{ record }">
      <p>{{record.amount_text}}</p>
      <p>{{record.use_condition}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' :ghost="!record.select" v-if='!checkout'>{{!record.select ?
        "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>{{!record.select ? "选择":"已选择"}}
      </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-25" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>

    <a-modal :keyboard="false" title="数量" v-model:visible="needNumberVisible" centered :width="400" @ok="numberOk"  destroyOnClose>
         <a-input-number v-model:value="coupon_num" :min="1" :precision="0" style="width:350px"></a-input-number>
  </a-modal>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getNewCouponList } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import store from "@/store";
import { isArray } from 'lodash';
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
    type:'all',
    keyword: "",
    status: 1,
    coupon_type: '',
    start_time:'',
    end_time:'',
    valid_period:1
  };
  export default {
    name: "selectCoupon",
    components: {},
    props: {
      selectList: {
        type: Array
      },
      checkout: {
        type: Boolean
      },
      selectLimit:{
        type:Number
      },
      needNum:{
        type:Boolean,
        default(){
          return false
        }
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        coupon_num:1,//优惠劵数量
        selectCurrent:null,
        needNumberVisible:false,//是否需要输入数量
        info: store.state.user.info,
        listLoading: false,
        total: 1,
        selectList: [],
        checkout: false,
      });
      let columns = [
      {
          title: "卡券ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "优惠",
          key: "amount_text",
          dataIndex:"amount_text",
          align:"center",
          slots: { customRender: "amount_text" },
        },
        {
          title: "券类型",
          dataIndex: "coupon_type_text",
          key: "coupon_type_text",
        },
        {
          title: "有效期",
          key: "valid_period_time",
          dataIndex:'valid_period_time'
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: ({ record }) => {
            return record.remark ? record.remark : '-'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        e.select = !e.select
        if(props.needNum){
          state.needNumberVisible=true
          state.selectCurrent=e
        }else{
           emit("select", e);
        }
      }
      //多选
      const checkBnt = (e) => {
        if(props.selectLimit && state.selectList.length == 5 && !e.select){
          message.error('最多只能选择'+props.selectLimit+'张优惠券！');
          return
        }
        if(!e.select){
          state.selectList.push(e)
        }else{
          // state.selectList
          var key=-1
          state.selectList.forEach((v,k)=>{
            if(v.id==e.id){
              key=k
            }
          })
          if(key!=-1){
            state.selectList.splice(key,1)
          }
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () => {
       if(props.needNum){
          state.needNumberVisible=true
          state.selectCurrent=state.selectList
        }else{
           emit("select", state.selectList);
        }
      }
      const numberOk=()=>{
        if(isArray(state.selectCurrent)){
          state.selectCurrent.map(v=>{
            if(!v.coupon_num){
              v['coupon_num']=state.coupon_num
            }
            return v
          })
        }else{
          state.selectCurrent['coupon_num']=state.coupon_num
        }
        emit("select", state.selectCurrent);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getNewCouponList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
            if (state.selectList.length > 0) {
              data.value.forEach(i => {
                if (state.selectList.find(v => i.id == v.id)) {
                  i.select = true
                }else{
                  i.select = false
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        console.log(props.selectList)
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        checkBnt,
        confirm,
        numberOk
      };
    },
  };
</script>